import api from "../../system/api";
import {getStorage} from "../../system/storage";

// Project updates (backend: src/projects in zofino-strapi; docs/tasks/18-project-updates.md).

const data = (response) => response?.data?.data;
const config = () => ({headers: {workspace: getStorage("workspace")}});

export const projectUpdateApi = {
    context: async (project) => data(await api.get(`/project-updates/project/${project}/context`, config())),
    createDraft: async (project, update) => data(await api.post(`/project-updates/project/${project}/drafts`, {data: update}, config())),
    saveDraft: async (documentId, update) => data(await api.put(`/project-updates/item/${documentId}`, {data: update}, {...config(), suppressGlobalErrorHandler: true})),
    deleteDraft: async (documentId) => data(await api.delete(`/project-updates/item/${documentId}`, config())),
    publish: async (documentId, update) => data(await api.post(`/project-updates/item/${documentId}/publish`, {data: update}, {...config(), suppressGlobalErrorHandler: true})),
    get: async (documentId) => data(await api.get(`/project-updates/item/${documentId}`, config())),
    // «ارسال به‌صورت پیام»: {people, chats, note} → card messages in private chats and group chats
    share: async (documentId, payload) => data(await api.post(`/project-updates/item/${documentId}/share`, {data: payload}, config())),
    saveLayout: async (widgets) => data(await api.put("/project-updates/me/layout", {data: {widgets}}, config())),
    setReminder: async (project, reminderRhythm) => data(await api.put(`/project-updates/project/${project}/reminder`, {data: {reminderRhythm}}, config())),
};

export const PROJECT_STATES = {
    "on-way": {label: "در مسیر", icon: "check_circle", tone: "green", open: true},
    "has-risks": {label: "در معرض ریسک", icon: "warning", tone: "orange", open: true},
    "out-of-way": {label: "خارج از مسیر", icon: "error", tone: "red", open: true},
    achieved: {label: "بدست آمده", icon: "stars", tone: "green", open: false},
    canceled: {label: "لغو شده", icon: "cancel", tone: "gray", open: false},
    archived: {label: "بیخیالش شدیم", icon: "delete_forever", tone: "gray", open: false},
};
export const OPEN_PROJECT_STATES = ["on-way", "has-risks", "out-of-way"];
export const CLOSED_PROJECT_STATES = ["achieved", "canceled", "archived"];

export const REMINDER_RHYTHMS = [
    {value: "weekly", label: "هفتگی (شنبه‌ها)"},
    {value: "two-weeks", label: "دو هفته یک‌بار"},
    {value: "monthly", label: "ماهانه (اول هر ماه)"},
    {value: "seasonally", label: "فصلی (اول هر فصل)"},
];

export const OFF_TRACK_PATHS = [
    {value: "replan", label: "بازطراحی برنامه"},
    {value: "scope", label: "تغییر محدوده"},
    {value: "owner", label: "تغییر مسئول"},
    {value: "resources", label: "افزایش منابع"},
    {value: "due_date", label: "تغییر تاریخ پایان"},
    {value: "pause", label: "توقف موقت"},
    {value: "propose_close", label: "پیشنهاد بستن پروژه"},
];

export const TASK_ACTIONS = [
    {value: "mark_done", label: "انجام شده بود (تکمیل)"},
    {value: "cancel", label: "لغو شود"},
    {value: "move_to_project", label: "انتقال به پروژه دیگر"},
    {value: "move_out", label: "خروج از پروژه (کار مستقل)"},
    {value: "keep", label: "به‌عنوان اقدام پس از پروژه بماند"},
];

export const MILESTONE_RESULTS = [
    {value: "achieved", label: "محقق شد"},
    {value: "partial", label: "نیمه‌کاره"},
    {value: "not_achieved", label: "محقق نشد"},
    {value: "canceled", label: "لغو شد"},
];

export const emptyProjectUpdate = (state = null) => ({
    selectedState: state,
    summary: "",
    accomplishments: "",
    obstacles: "",
    nextActions: "",
    widgets: null,
    stateDetails: {
        mismatchReason: "",
        risk: {description: "", impact: "", owner: null, action: "", reviewAt: null},
        offTrack: {cause: "", projectImpact: "", goalImpact: "", decision: "", decisionOwner: null, decisionAt: null, path: null},
    },
    closure: {result: "", evidence: "", reason: "", decisionMaker: null, replacementProject: null, lastState: "", lessons: "", tasks: [], milestones: [], goals: []},
});

const lines = (value) => (Array.isArray(value) ? value : String(value || "").split("\n")).map((line) => String(line).trim()).filter(Boolean);

// form (text areas hold one item per line) → API body
export function toProjectUpdateBody(form, widgets) {
    return {
        ...form,
        accomplishments: lines(form.accomplishments),
        obstacles: lines(form.obstacles),
        nextActions: lines(form.nextActions),
        widgets,
    };
}

// a saved draft → form
export function fromProjectUpdate(update) {
    const empty = emptyProjectUpdate();
    return {
        ...empty,
        selectedState: update?.selectedState || null,
        summary: update?.summary || "",
        accomplishments: (update?.accomplishments || []).join("\n"),
        obstacles: (update?.obstacles || []).join("\n"),
        nextActions: (update?.nextActions || []).join("\n"),
        widgets: update?.widgets?.length ? update.widgets : null,
        stateDetails: {
            mismatchReason: update?.stateDetails?.mismatchReason || "",
            risk: {...empty.stateDetails.risk, ...(update?.stateDetails?.risk || {})},
            offTrack: {...empty.stateDetails.offTrack, ...(update?.stateDetails?.offTrack || {})},
        },
        closure: {...empty.closure, ...(update?.closure || {})},
    };
}
